import React from 'react';
import ReportsTours from '../components/Reports/ReportsTours';
import '../components/LiveIntel/liveIntel.css';
import '../components/Reports/reports.css';

const ReportsToursPage = () => <ReportsTours />;

export default ReportsToursPage;
